import { defineAsyncComponent } from 'vue'
export default {
  asuostaticlayout: defineAsyncComponent(() => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/layouts/asuostaticlayout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/layouts/default.vue").then(m => m.default || m))
}